import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TeamsCallingCallPickupGroup } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class CallPickupGroupsResource {
  private http = inject(HttpClient);

  get(tenantId: string, upn: string): Observable<TeamsCallingCallPickupGroup> {
    return this.http.get<TeamsCallingCallPickupGroup>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/teams-calling-call-pickup-group/${encodeURIComponent(upn)}`,
    );
  }
}
